import React, { FunctionComponent } from 'react';

import AntecedentModificationForm from './AntecedentModificationForm';
import Step from 'src/components/common/Step';

interface AntecedentModificationModalContentProps {
  currentStep: number;
  onClose: () => void;
  onNext: () => void;
  onPrevious: () => void;
  onSubmit: () => void;
  patientId: string;
  setRecord: (record: any) => void;
  record: any;
}

export const AntecedentModificationModalContent: FunctionComponent<AntecedentModificationModalContentProps> =
  ({ currentStep, onClose, onPrevious, patientId, record }) => {
    return (
      <>
        <Step step={0} currentStep={currentStep}>
          <AntecedentModificationForm
            patientId={patientId}
            antecedent={record}
            onClose={onClose}
            onPrevious={onPrevious}
          />
        </Step>
      </>
    );
  };

export default AntecedentModificationModalContent;
